import { computed, toShortAddress, useHead } from '#imports';
import type { RouteLocationNormalizedLoadedGeneric } from '#vue-router';
import profile from '@/assets/images/profile.webp';

export const useMetaProfile = ({ user, route }: {
    user: Nullable<User['address']>;
    route: RouteLocationNormalizedLoadedGeneric;
}) => {
    const shortAddress = computed(() => user ? toShortAddress(user) : '');

    const imageSize = 1200;

    const pathWithoutParams = import.meta.env.VITE_DOMEN_URL + route.path;
    const pathWithParams = import.meta.env.VITE_DOMEN_URL + route.fullPath;

    const runtimeConfig = useRuntimeConfig();

    useHead({
        title: `${shortAddress.value} — Profile | ${runtimeConfig.public.name}`,
        meta: [
            {
                property: 'og:title',
                content: `${shortAddress.value} — Profile | ${runtimeConfig.public.name}`
            },
            {
                property: 'og:image:type',
                content: 'image/png'
            },
            {
                property: 'og:image:width',
                content: `${imageSize}`
            },
            {
                property: 'og:image:height',
                content: `${imageSize}`
            },
            {
                property: 'og:image',
                content: profile
            },
            {
                property: 'og:image:alt',
                content: `${shortAddress.value} — Profile | ${runtimeConfig.public.name}`
            },
            {
                property: 'og:description',
                content: `Check out ${shortAddress.value}’s NFTs on ${runtimeConfig.public.name}, the go-to marketplace for gamers.`
            },
            {
                name: 'description',
                content: `Check out ${shortAddress.value}’s NFTs on ${runtimeConfig.public.name}, the go-to marketplace for gamers.`
            },
            {
                name: 'twitter:title',
                content: `${shortAddress.value} — Profile | ${runtimeConfig.public.name}`
            },
            {
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                name: 'twitter:url',
                content: pathWithoutParams
            },
            {
                name: 'twitter:creator',
                content: `${shortAddress.value}`
            },
            {
                name: 'twitter:image',
                content: profile
            },
            {
                name: 'twitter:description',
                content: `Check out ${shortAddress.value}’s NFTs on ${runtimeConfig.public.name}, the go-to marketplace for gamers.`
            }
        ],
        link: [
            {
                rel: 'canonical',
                href: pathWithParams
            },
            {
                rel: 'preconnect',
                href: pathWithParams
            },
            {
                rel: 'dns-prefetch',
                href: pathWithParams
            }
        ]
    });
};
